class DialogoServico {
  alerta(opcoes = {}, callback) {
    const api = typeof window !== 'undefined' ? window.__cardeaDialog : null
    const payload = typeof opcoes === 'string' ? { content: opcoes } : opcoes

    if (api && typeof api.alert === 'function') {
      api.alert(payload).then(() => {
        if (typeof callback === 'function') {
          callback()
        }
      })
      return
    }

    const conteudo = payload.content || payload.message || ''

    if (typeof window !== 'undefined' && typeof window.alert === 'function') {
      window.alert(conteudo)
    }

    if (typeof callback === 'function') {
      callback()
    }
  }
}

export default DialogoServico
